/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ServicesService {
    /**
     * Get all services
     * @returns any Services retrieved successfully
     * @throws ApiError
     */
    public static getApiV2Services(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/services',
        });
    }
    /**
     * Create a new service
     * @param requestBody
     * @returns any Service created successfully
     * @throws ApiError
     */
    public static postApiV2Services(
        requestBody: {
            categoryname?: string;
            itemname?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/services',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get services by category
     * @param category
     * @returns any Services retrieved successfully
     * @throws ApiError
     */
    public static getApiV2ServicesCategory(
        category: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/services/category/{category}',
            path: {
                'category': category,
            },
        });
    }
    /**
     * Get service by ID
     * @param id
     * @returns any Service retrieved successfully
     * @throws ApiError
     */
    public static getApiV2Services1(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/services/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Update a service
     * @param id
     * @param requestBody
     * @returns any Service updated successfully
     * @throws ApiError
     */
    public static putApiV2Services(
        id: number,
        requestBody: {
            categoryname?: string;
            itemname?: string;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v2/services/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Delete a service
     * @param id
     * @returns any Service deleted successfully
     * @throws ApiError
     */
    public static deleteApiV2Services(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v2/services/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Get services by location ID
     * @param id
     * @returns any Services retrieved successfully
     * @throws ApiError
     */
    public static getApiV2ServicesLocation(
        id: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/services/location/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Add services to location
     * @param id
     * @param requestBody
     * @returns any Services added successfully
     * @throws ApiError
     */
    public static postApiV2ServicesLocation(
        id: number,
        requestBody: {
            services?: Array<number>;
            buying?: boolean;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v2/services/location/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Remove services from location
     * @param id
     * @param requestBody
     * @returns any Services removed successfully
     * @throws ApiError
     */
    public static deleteApiV2ServicesLocation(
        id: number,
        requestBody: {
            services?: Array<number>;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v2/services/location/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
